/*
 * Dashboard Messages
 *
 * This contains all the text for the Dashboard component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  inactivityWarning: {
    id: 'app.components.Dashboard.inactivityWarning',
    defaultMessage:
      'Dear Friend, since you have not been able to participate in a shift for a while, we ask you to apply for a shift soon, in order for your user account to not be deactivated.',
  },
  missingShiftleaders: {
    id: 'app.components.Dashboard.missingShiftleaders',
    defaultMessage: 'Missing Team Leaders ({amount})',
  },
  noShiftLeaderYet: {
    id: 'app.components.Dashboard.noShiftLeaderYet',
    defaultMessage: 'No Team Leader applied yet',
  },
  upcomingAssignments: {
    id: 'app.components.Dashboard.upcomingAssignments',
    defaultMessage: 'Upcoming Assignments',
  },
  assigned: {
    id: 'app.components.Dashboard.assigned',
    defaultMessage: 'You are assigned',
  },
  assignedAsShiftLeader: {
    id: 'app.components.Dashboard.assignedAsShiftLeader',
    defaultMessage: 'You are assigned as team leader',
  },
  shiftCanceled: {
    id: 'app.components.Dashboard.shiftCanceled',
    defaultMessage: 'This shift is canceled',
  },
  noUpcomingAssignments: {
    id: 'app.components.Dashboard.noUpcomingAssignments',
    defaultMessage: 'You did not get assigned for any upcoming shifts',
  },
  uncompletedTurnReports: {
    id: 'app.components.Dashboard.uncompletedTurnReports',
    defaultMessage: 'Uncompleted Reports',
  },
  noUncompletedTurnReports: {
    id: 'app.components.Dashboard.noUncompletedTurnReports',
    defaultMessage: 'You have no uncompleted reports',
  },
  unassignedApplications: {
    id: 'app.components.Dashboard.unassignedApplications',
    defaultMessage: 'Open Applications',
  },
  appliedOn: {
    id: 'app.components.Dashboard.appliedOn',
    defaultMessage: 'Applied on {appliedOn}',
  },
  regularApplication: {
    id: 'app.components.Dashboard.regularApplication',
    defaultMessage: 'Regular application',
  },
  regularApplicationWeekly: {
    id: 'app.components.Dashboard.regularApplicationWeekly',
    defaultMessage:
      'Regular application for every {nthWeek, selectordinal, one {} two {2nd} few {3rd} other {#th}} week',
  },
  regularApplicationMonthly: {
    id: 'app.components.Dashboard.regularApplicationMonthly',
    defaultMessage:
      'Regular application for every {nth, selectordinal, one {1st} two {2nd} few {3rd} other {#th}} {weekday} of the month',
  },
  noUnassignedApplications: {
    id: 'app.components.Dashboard.noUnassignedApplications',
    defaultMessage: 'You have no open applications',
  },
});
